<template>
  <span class="ui-icon-base component" v-on="$listeners">
    <component :is="iconName" :width="width" :height="height" :color="color"> </component>
  </span>
</template>

<script>
export default {
  name: 'UiIconBase',

  components: {
    write: () => import('./write.vue'),
    moon: () => import('./moon.vue'),
    done: () => import('./done.vue'),
    arrowDown: () => import('./arrowDown.vue'),
    sort: () => import('./sort.vue'),
    sortDown: () => import('./sortDown.vue'),
    sortUp: () => import('./sortUp.vue'),
    human: () => import('./human.vue'),
    creditCard: () => import('./creditCard.vue'),
    dollar: () => import('./dollar.vue'),
    face: () => import('./face.vue'),
    grading: () => import('./grading.vue'),
    cardprLogo: () => import('./cardprLogo.vue'),
    menuHamburger: () => import('./menuHamburger.vue'),
    close: () => import('./close.vue'),
    exclamation: () => import('./exclamation.vue'),
    eye: () => import('./eye.vue'),
    eyeClose: () => import('./eyeClose.vue'),
    search: () => import('./search.vue'),
    arrowLeft: () => import('./arrowLeft.vue'),
    moreHoriz: () => import('./moreHoriz.vue'),
    chevronDown: () => import('./chevronDown.vue'),
    block: () => import('./block.vue'),
    plusCircle: () => import('./plusCircle.vue'),
    timeline: () => import('./timeline.vue'),
    logout: () => import('./logout.vue'),
    cog: () => import('./cog.vue'),
    filterColumn: () => import('./filterColumn.vue'),
    unplugged: () => import('./unplugged.vue'),
    save: () => import('./save.vue'),
    bolt: () => import('./bolt.vue'),
  },
  props: {
    iconName: {
      type: String,
      default: 'moon',
    },
    width: {
      type: String,
      default: '18px',
    },
    height: {
      type: String,
      default: '18px',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-icon-base.component {
  display: flex;
}
</style>
